

export default {
  props: {
    item: {
      default: () => Object,
      type: Object
    },
    showEmptyChips: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      color: 'grey lighten-4',
      clazz: 'mt-1'
    }
  },
  methods: {
    showChip (attributeCode, value) {
      if (this.showEmptyChips) {
        return true
      }

      if (value === undefined || value === null) {
        return false
      }
      return true
    },

    format (attributeCode, value) {
      return this.$eavFormatter.formatUploadAttribute(attributeCode, value)
    }
  }
}
